import http from '@/lib/http'
import { useQuery } from '@tanstack/react-query'

type APILinkedPatient = {
  hash: string
  first_name: string
  last_name: string
  date_of_birth: string | null
  gender: string | null
  postal_code: string | null
}

type APILinkedPatientsResponse = {
  linked_patient_hash: string
  patients: APILinkedPatient[]
}

export interface LinkedPatient {
  hash: string
  firstName: string
  lastName: string
  dateOfBirth: string | null
  gender: string | null
  postcode: string | null
}

function toLinkedPatient(api: APILinkedPatient): LinkedPatient {
  return {
    hash: api.hash,
    firstName: api.first_name,
    lastName: api.last_name,
    dateOfBirth: api.date_of_birth,
    gender: api.gender,
    postcode: api.postal_code
  }
}

export const fetchLinkedPatients = async (linkedPatientHash: string): Promise<LinkedPatient[]> => {
  const { patients } = (await http.get(`/patients/linked/${linkedPatientHash}`)) as APILinkedPatientsResponse

  return patients.map(toLinkedPatient)
}

export const useLinkedPatientsQuery = (
  linkedPatientHash: string | null | undefined,
  excludePatientHash?: string | null
) => {
  return useQuery({
    queryKey: ['linkedPatients', linkedPatientHash],
    queryFn: () => fetchLinkedPatients(linkedPatientHash as string),
    select: patients => patients.filter(patient => patient.hash !== excludePatientHash),
    enabled: !!linkedPatientHash,
    staleTime: 5 * 60 * 1000
  })
}
